import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-advt-invoice-monthwise-register',
  templateUrl: './advt-invoice-monthwise-register.component.html',
  styleUrl: './advt-invoice-monthwise-register.component.scss'
})
export class AdvtInvoiceMonthwiseRegisterComponent {

startDate;
  endDate;
  today;
 issue_name;
issue_date;
  reportType;
  advtInvoiceData;
  filteredAdvtInvoiceData : any;
  isLoading = false;
  printShowData = [];
  filteredPrintShowData = [];
  sdate: any;
  enddate: any;
  invoiceNumber: any;
  issuedate: any;
  invoiceName: any;
  advtamount: any;
  discountamt: any;
  netamount: any;
  gstcst: any;
  invoicetotalamount:any;
  
  totalinvoiceamount: any;
   paidamount: any;
   unpaidAmt:any;
  // paid_amount: any;
  filteredAdvtInvoiceDatamonthly: any;
  netamountm: any;
  advtamountm: any;
  gstcstm: any;
  paidamountm: any;
  filteredAdvtInvoiceDatabrifly: any;
  beforegst: any;
  tcgst: any;
  tsgst: any;
  tigst: any;
  tgst: any;
  totalamount: any;
  cgst: number;
  sgst: number;
  igst: number;
  invoice_total: any;
  paid_amount:any;
  additionOfUnpaidAmount: number;
  totalbeforegstamount : number;
  UnpaidAmount:number;
  rcvamount:number;
  beforegstamount:number;

  constructor(
    private dialogRef: MatDialogRef<AdvtInvoiceMonthwiseRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    
    this.isLoading = false;
    this.today = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.issue_name = this.data['issue_name'];
    this.issue_date = this.data['issue_date'];
    this.reportType = this.data['reportType'];
    this.sdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    // this.invoiceName = this.data['issueName'];
    // this.issuedate = this.data['issueDates'];
    // this.advtInvoiceData = this.data['advtData'];
    // console.log(this.data);

    console.log(this.sdate, this.enddate, this.issue_name, this.issue_date, "data");

    this.getData();
  }
additionOfUnpaidAMount:number
 
  getData() {
    

    const req:any = {
      "start_date":this.sdate,
      "end_date":this.enddate,
      "issue_name":this.issue_name,
      "issue_date":this.issue_date,
      
    }
    this.service.getAdvtInvoiceRegisterListbriefly(req).subscribe((res: any) => {
      console.log(res);
      debugger
      this.filteredAdvtInvoiceData = res;
      this.advtamount =0;
      this.discountamt =0;
      this.netamount =0;
      
      this.invoice_total =0;
      this.paid_amount=0;
      this.cgst =0;
      this.sgst =0;
      this.igst =0;
      this.gstcst =0;
      this.totalinvoiceamount =0;
      this. paidamount =0;
      this.additionOfUnpaidAMount=0
    //   for (let data1 of this.filteredAdvtInvoiceData) {
    //     console.log( data1.advt_amt, "advt amt")
    //     this.advtamount += parseInt(data1.advt_amt) || 0;
    //     this.discountamt += parseInt(data1.discount) || 0;
    //     this.netamount += parseInt(data1.net_amt) || 0;
    //     this.cgst += parseInt(data1.cgst) || 0;
    //     this.sgst += parseInt(data1.sgst) || 0;
    //     this.igst += parseInt(data1.igst) || 0;
    //     this.gstcst += parseInt(data1.gst) || 0;
    //     this.totalinvoiceamount += parseInt(data1.amount) || 0;
    //     this.paidamount += parseInt(data1.received_amt) || 0;
    // }
    for (let data1 of this.filteredAdvtInvoiceData) {
      console.log(data1.advt_amt, "advt amt");
      debugger
       const advtAmt = parseFloat(data1.advt_amt) || 0;
    const discountAmt = parseFloat(data1.discount) || 0;
     const before_gst_amount_db = parseFloat(data1.before_gst_amount_db) || 0;

    const netAmt = parseFloat(data1.net_amt) || 0;
    const invoiceTotal = parseFloat(data1.invoice_total) || 0;
    const cgstAmt = parseFloat(data1.cgst) || 0;
    const sgstAmt = parseFloat(data1.sgst) || 0;
    const igstAmt = parseFloat(data1.igst) || 0;
    const gstAmt = parseFloat(data1.gst) || 0;
    const totalInvoiceAmt = parseFloat(data1.amount) || 0;
    const paidAmt = parseFloat(data1.received_amt) || 0;
      // const paidAmt = parseFloat(data1.paidamount) || 0;
    const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
    

    // Add to totals (round after addition for better precision)
    this.advtamount += advtAmt;
    this.discountamt += discountAmt;
    this.netamount += netAmt;
    this.invoice_total += invoiceTotal;

    this.cgst += cgstAmt;
    this.sgst += sgstAmt;
    this.igst += igstAmt;
    this.gstcst += gstAmt;
    this.totalinvoiceamount += totalInvoiceAmt;
    this.paid_amount += paidAmt;
    this.additionOfUnpaidAmount += unpaidAmt;
  

  } 

  
    console.log( this.advtamount, "total advt")
    });

 
this.service.getAdvtInvoiceRegisterListmonthly(req).subscribe((res: any) => {
    console.log(res);
    this.filteredAdvtInvoiceDatamonthly = res;

    // Initialize all variables to 0
    this.rcvamount = 0; // CHANGED: from this.paid_amount to this.paidamount
    this.discountamt = 0;
    this.UnpaidAmount = 0;
    this.tcgst = 0;
    this.tsgst = 0;
    this.tigst = 0;
    this.tgst = 0;
    this.beforegstamount = 0;
    this.invoicetotalamount = 0;
    this.advtamount = 0;

    // Perform calculations only if the data is available
    if (this.filteredAdvtInvoiceDatamonthly && this.filteredAdvtInvoiceDatamonthly.length > 0) {
        for (let data1 of this.filteredAdvtInvoiceDatamonthly) {
            // Add advertisement amount
            this.advtamount += parseFloat(data1.advt_amt) || 0;

            // Add discount amount
            this.discountamt += parseFloat(data1.total_discount_rate) || 0;

            // GST calculations
            this.tcgst += parseFloat(data1.cgst) || 0;
            this.tsgst += parseFloat(data1.sgst) || 0;
            this.tigst += parseFloat(data1.igst) || 0;
            this.tgst += parseFloat(data1.gst) || 0;

            // Add beforegst amount
            this.beforegstamount += parseFloat(data1.beforegst_amount) || 0;

            // Total amount
            this.invoicetotalamount += parseFloat(data1.amount) || 0;

            // CHANGED: from this.paid_amount to this.paidamount
            this.rcvamount += parseFloat(data1.received_amt) || 0;

            // Add unpaid amount
            this.UnpaidAmount += parseFloat(data1.pending_amt) || 0;
        }

        console.log('Before GST Total:', this.beforegst);
        console.log('Unpaid Amount Total:', this.UnpaidAmount);
        console.log('Paid Amount Total:', this.paidamount); // This should now show correct value
    }
});
   
    

    this.service.getAdvtInvoiceRegisterListbriefly(req).subscribe((res: any) => {
      console.log(res);
      this.filteredAdvtInvoiceDatabrifly = res;
      this.beforegst = 0;
      this.tcgst =  0;
      //  this.paid_amount=0;
      this.tsgst =  0;
      this.tigst =  0;
      this.tgst = 0;
       this. paidamount =0;
      this.totalamount =0;
      this.totalinvoiceamount =0;
      this.totalbeforegstamount =0;
      this.unpaidAmt = 0;
      // this. paidamount =0;
      this.additionOfUnpaidAMount=0
      for (let data1 of this.filteredAdvtInvoiceDatabrifly) {
       
        this.tcgst += parseFloat(data1.cgst) || 0;
        this.tsgst += parseFloat(data1.sgst) || 0;
        this.tigst += parseFloat(data1.igst) || 0;
        this.tgst += parseFloat(data1.gst) || 0;
        this.totalbeforegstamount += parseFloat(data1.beforegst_amt) || 0;
        this.totalamount += parseFloat(data1.amount) || 0;
        const paidAmt = parseFloat(data1.paid_amount) || 0;
       this.unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
    }
    });
  }

  filterData() {
    // console.log('called');
    if (this.startDate == '' && this.endDate == '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData;
      // console.log('filteredData', this.advtInvoiceData);
    } else if (this.startDate !== '' && this.endDate !== '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData.filter((a) => {
        return (
          a['invoice_date'] >= this.startDate &&
          a['invoice_date'] <= this.endDate
        );
      });
      // console.log('filteredData', this.advtInvoiceData);
    }

    setTimeout(() => {
      this.setData();
    }, 700);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  setData() {
    // console.log(this.advtInvoiceData);
    // console.log(this.advtInvoiceData);
    if (this.advtInvoiceData.length == 0) {
      this.isLoading = false;
      alert('Data is not Present.');
      this.dialogRef.close();
    }
    let data = this.uniqueid(this.advtInvoiceData, (a) => a.advt_name);
    // console.log(data);
    for (let index = 0; index < this.advtInvoiceData.length; index++) {
      // let eachData = this.advtInvoiceData.filter(
      //   (a) => data[i]['advt_name'] == a.advt_name
      // );

      let showData = {
        issue_name: '',
        invoice_no: '',
        invoice_date: '',
        advt_name: '',
        client_name: '',
        rep_name: '',
        off_rep_name: '',
        firstweek_issue_date: '',
        secondweek_issue_date: '',
        thirdweek_issue_date: '',
        fourthweek_issue_date: '',
        fifthweek_issue_date: '',
        total_advt_amt: 0,
        total_dis: 0,
        total_net: 0,
        total_cgst: 0,
        total_sgst: 0,
        total_igst: 0,
        total_amt: 0,
      };

      // if (Object.keys(eachData).length > 0) {
      console.log('called', this.advtInvoiceData);
      // for (let index = 0; index < this.advtInvoiceData.length; index++) {
      if (
        this.advtInvoiceData[index]['first_week_id'] != null &&
        this.advtInvoiceData[index]['first_week_issue_name'] ===
          this.issue_name &&
        this.issue_date.includes(
          this.advtInvoiceData[index]['first_week_issue_date']
        )
      ) {
        // console.log('first');
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
          console.log(  showData['issue_name'], "new issue name");

        showData['firstweek_issue_date'] =
          this.advtInvoiceData[index]['first_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['first_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['first_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['second_week_id'] != null &&
        this.advtInvoiceData[index]['second_week_issue_name'] ===
          this.issue_name &&
        this.issue_date.includes(
          this.advtInvoiceData[index]['second_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['secondweek_issue_date'] =
          this.advtInvoiceData[index]['second_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['second_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['second_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['third_week_id'] != null &&
        this.advtInvoiceData[index]['third_week_issue_name'] ===
          this.issue_name &&
        this.issue_date.includes(
          this.advtInvoiceData[index]['third_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['thirdweek_issue_date'] =
          this.advtInvoiceData[index]['third_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['third_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['third_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fourth_week_id'] != null &&
        this.advtInvoiceData[index]['fourth_week_issue_name'] ===
          this.issue_name &&
        this.issue_date.includes(
          this.advtInvoiceData[index]['fourth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fourthweek_issue_date'] =
          this.advtInvoiceData[index]['fourth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fifth_week_id'] != null &&
        this.advtInvoiceData[index]['fifth_week_issue_name'] ===
          this.issue_name &&
        this.issue_date.includes(
          this.advtInvoiceData[index]['fifth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fifthweek_issue_date'] =
          this.advtInvoiceData[index]['fifth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_total_amount']
        );
      }
      // }
      if (
        (this.advtInvoiceData[index]['first_week_issue_name'] ===
          this.issue_name &&
          this.issue_date.includes(
            this.advtInvoiceData[index]['first_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['second_week_issue_name'] ===
          this.issue_name &&
          this.issue_date.includes(
            this.advtInvoiceData[index]['second_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['third_week_issue_name'] ===
          this.issue_name &&
          this.issue_date.includes(
            this.advtInvoiceData[index]['third_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fourth_week_issue_name'] ===
          this.issue_name &&
          this.issue_date.includes(
            this.advtInvoiceData[index]['fourth_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fifth_week_issue_name'] ===
          this.issue_name &&
          this.issue_date.includes(
            this.advtInvoiceData[index]['fifth_week_issue_date']
          ))
      ) {
        showData['invoice_no'] = this.advtInvoiceData[0]['invoice_no'];
        showData['invoice_date'] = this.advtInvoiceData[0]['invoice_date'];
        showData['advt_name'] = this.advtInvoiceData[0]['advt_name'];
        showData['client_name'] = this.advtInvoiceData[0]['cust_name'];
        showData['rep_name'] = this.advtInvoiceData[0]['rep_name'];
        showData['off_rep_name'] = this.advtInvoiceData[0]['off_rep_name'];

        this.printShowData.push(showData);
      }

      // console.log('showData', showData);
      // }
      console.log('printShowData', this.printShowData);
      if (index == data.length - 1) {
        this.isLoading = false;
        this.filterPrintShowData();
      }
    }
  }

  filterPrintShowData() {
    let data = this.uniqueid(this.printShowData, (a) =>
      formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530')
    );
    // console.log(data);
    let totalAdvtAmt1 = 0;
    let totalDisAmt1 = 0;
    let totalNetAmt1 = 0;
    let totalCGST1 = 0;
    let totalSGST1 = 0;
    let totalIGST1 = 0;
    let totalInvoiceAmount1 = 0;
    for (let index = 0; index < data.length; index++) {
      let filteredData = this.printShowData.filter((a) => {
        return (
          formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530') ==
          formatDate(data[index]['invoice_date'], 'MM', 'en-IN', 'GMT+0530')
        );
      });
      // console.log(filteredData);
      let totalAdvtAmt = 0;
      let totalDisAmt = 0;
      let totalNetAmt = 0;
      let totalCGST = 0;
      let totalSGST = 0;
      let totalIGST = 0;
      let totalInvoiceAmount = 0;
      let issue_date = '';
      for (let i = 0; i < filteredData.length; i++) {
        totalAdvtAmt += parseInt(filteredData[index]['total_advt_amt']);
        totalDisAmt += parseInt(filteredData[index]['total_dis']);
        totalNetAmt += parseInt(filteredData[index]['total_net']);
        totalCGST += parseInt(filteredData[index]['total_cgst']);
        totalSGST += parseInt(filteredData[index]['total_sgst']);
        totalIGST += parseInt(filteredData[index]['total_igst']);
        totalInvoiceAmount += parseInt(filteredData[index]['total_amt']);
        issue_date = filteredData[index]['invoice_date'];
      }

      filteredData.push({
        issue_date,
        totalAdvtAmt,
        totalDisAmt,
        totalNetAmt,
        totalCGST,
        totalSGST,
        totalIGST,
        totalInvoiceAmount,
      });

      totalAdvtAmt1 += totalAdvtAmt;
      totalDisAmt1 += totalDisAmt;
      totalNetAmt1 += totalNetAmt;
      totalCGST1 += totalCGST;
      totalSGST1 += totalSGST;
      totalIGST1 += totalIGST;
      totalInvoiceAmount1 = totalInvoiceAmount;

      this.filteredPrintShowData.push(filteredData);
    }

    this.filteredPrintShowData.push({
      totalAdvtAmt1,
      totalDisAmt1,
      totalNetAmt1,
      totalCGST1,
      totalSGST1,
      totalIGST1,
      totalInvoiceAmount1,
    });

    console.log(this.filteredPrintShowData);
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  issuedatereturn(dates){
    if(dates!=null){
      let returnissuedate = dates.split(',');
      return returnissuedate[0];
    }else{
      return null;
    }
  
  }
  // print() {
  //   const originalTitle = document.title; // Store original title
  //   document.title = '';     // Set custom print title
  
  //   // Create a style tag for print-specific styles
  //   const style = document.createElement('style');
  //   style.innerHTML = `
  //     @media print {
  //       @page {
  //         size: A4;
  //         margin: 20mm;
  //       }
  //       .print-header {
  //         text-align: center;
  //         font-size: 16px;
  //         font-weight: bold;
  //         margin-bottom: 10px;
  //       }
  //       .print-footer {
  //         position: fixed;
  //         bottom: 10px;
  //         left: 0;
  //         right: 0;
  //         text-align: center;
  //         font-size: 12px;
  //         color: gray;
  //       }
  //       .print-footer::after {
  //         content: "Page " counter(page) " of " counter(pages);
  //       }
  //       .no-print {
  //         display: none !important;
  //       }
  //     }
  //   `;
  
  //   document.head.appendChild(style); // Add style to the document
  
  //   setTimeout(() => {
  //     const printTrigger = document.getElementById('print-button');
  //     if (printTrigger) (printTrigger as HTMLElement).click();
      
  //     document.title = ''; // Restore original title after printing
      
  //     // document.head.removeChild(style); // Remove the style after printing
  //   }, 500); // Delay ensures styles apply before printing
  // }

  show = false;
  //  printPage() {
  //        this.show = true;
  //        const printSection = document.getElementById('print-section');
  //        if (!printSection) {
  //            console.error("Print section not found!");
  //            return;
  //        }
       
  //        const printContent = printSection.innerHTML;
       
  //        const screenWidth = window.screen.availWidth;
     
  //        const windowWidth = 1000;
  //        const leftPosition = screenWidth - windowWidth - 50;
       
  //        const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
       
         
  //        if (printWindow) {
  //            printWindow.document.open();
  //            printWindow.document.write(`
  //                <html>
  //                    <head>
  //                        <title>Print Report</title>
  //                        <style>
  //                            @media print {
  //                                @page {
  //                                    size: A3 landscape;
  //                                    margin: 5mm;
  //                                }
  //                                body {
  //                                    font-family: Arial, sans-serif;
  //                                    margin: 0;
  //                                    padding: 0;
  //                                    font-size: 14px !important;
  //                                }
  //                                .print-section {
  //                                    width: 100%;
  //                                    margin: 0 auto;
  //                                    padding: 0;
  //                                }
  //                                table {
  //                                    width: auto !important;
  //                                    border-collapse: collapse;
  //                                    table-layout: auto;
  //                                    page-break-inside: auto;
  //                                    border: 1px solid black !important;
  //                                }
  //                                tr {
  //                                    page-break-inside: avoid;
  //                                    page-break-after: auto;
  //                                }
  //                                th, td {
  //                                    padding: 2px 3px !important;
  //                                    border: 1px solid black !important;
  //                                    font-size: 14px;
  //                                    line-height: 1.2;
  //                                    white-space: nowrap;
  //                                }
  //                                th {
  //                                    background-color: #f2f2f2;
  //                                    font-weight: bold;
  //                                }
  //                                tr {
  //                                    border-bottom: 1px solid black !important;
  //                                }
  //                                tr.header-row {
  //                                    display: table-header-group;
  //                                }
  //                                td[data-type="number"],
  //                                td.amount,
  //                                td.balance-value,
  //                                td:nth-child(n+12) {
  //                                    text-align: end !important;
  //                                }
  //                                td.text,
  //                                td[data-type="string"] {
  //                                    text-align: left !important;
  //                                }
  //                                .br-right { border-right: 1px solid black !important; }
  //                                .br-rightt { border-right: 1px solid black !important; }
  //                                .br-bottom { border-bottom: 1px solid black !important; }
  //                                .br-top { border-top: 1px solid black !important; }
  //                                .noPrint { display: none !important; }
  //                                .footer-line {
  //                                    position: fixed;
  //                                    bottom: 0;
  //                                    left: 0;
  //                                    width: 100%;
  //                                    height: 1px;
  //                                    background-color: black;
  //                                }
  //                                thead { 
  //                                    display: table-header-group; 
  //                                    border: 1px solid black !important;
  //                                }
  //                                tfoot { 
  //                                    display: table-footer-group; 
  //                                    border: 1px solid black !important;
  //                                }
  //                                /* Ensure all borders are displayed */
  //                                table, th, td {
  //                                    border-style: solid !important;
  //                                    border-width: 1px !important;
  //                                    border-color: black !important;
  //                                }
  //                                /* Make sure header repeats on each page */
  //                                thead tr {
  //                                    display: table-row !important;
  //                                }
  //                            }
  //                        </style>
  //                    </head>
  //                    <body>
  //                        <div class="print-section">
  //                            ${printContent}
  //                            <div class="footer-line"></div>
  //                        </div>
  //                        <script>
  //                           window.onload = function () {
  //                               const table = document.querySelector('table');
  //                               if (!table) {
  //                                   console.error("Table not found");
  //                                   return;
  //                               }
     
  //                               // Auto-size columns based on content
  //                               table.style.width = 'auto';
  //                               const cols = table.querySelectorAll('td, th');
  //                               cols.forEach(cell => {
  //                                   cell.style.width = 'auto';
  //                                   cell.style.whiteSpace = 'nowrap';
  //                               });
     
  //                               let headerRowIndex = -1;
  //                               const maxRowsToCheck = Math.min(10, table.rows.length);
     
  //                               // Find header row with column names
  //                               for (let i = 0; i < maxRowsToCheck; i++) {
  //                                   const row = table.rows[i];
  //                                   const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
     
  //                                   if (row.cells.length >= 8 &&
  //                                       (cellTexts.includes('Invoice No') ||
  //                                        cellTexts.includes('Receipt No') ||
  //                                        cellTexts.includes('Balance'))) {
  //                                       headerRowIndex = i;
  //                                       break;
  //                                   }
  //                               }
     
  //                               if (headerRowIndex >= 0) {
  //                                   // Create thead and move only the actual header row into it
  //                                   let thead = table.querySelector('thead');
  //                                   if (!thead) {
  //                                       thead = document.createElement('thead');
  //                                       table.insertBefore(thead, table.firstChild);
  //                                   }
     
  //                                   const headerRow = table.rows[headerRowIndex];
  //                                   thead.appendChild(headerRow.cloneNode(true));
  //                               }
     
  //                               // Alignment processing
  //                               const cells = document.querySelectorAll('td');
  //                               cells.forEach(cell => {
  //                                   const content = cell.textContent.trim();
     
  //                                   if (content.includes('येणे') ||
  //                                       content.includes('Opening Balance') ||
  //                                       content.match(/^\\d+\\s+येणे$/) ||
  //                                       content.includes('Balance C/F') ||
  //                                       content.includes('Total')) {
  //                                       cell.style.textAlign = 'right';
  //                                       cell.classList.add('balance-value');
  //                                   }
     
  //                                   const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
  //                                   if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
  //                                       cell.style.textAlign = 'right';
  //                                       cell.classList.add('amount');
  //                                   }
     
  //                                   cell.style.border = '1px solid black';
  //                               });
     
  //                               setTimeout(() => {
  //                                   window.print();
  //                                   setTimeout(() => { window.close(); }, 500);
  //                               }, 200);
  //                           };
  //                        </script>
  //                    </body>
  //                </html>
  //            `);
  //            printWindow.document.close();
  //        } else {
  //            console.error("Failed to open print window.");
  //        }
  //    }


// printPage() {
//     this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//         console.error("Print section not found!");
//         return;
//     }
  
//     const printContent = printSection.innerHTML;
  
//     const screenWidth = window.screen.availWidth;

//     const windowWidth = 1000;
//     const leftPosition = screenWidth - windowWidth - 50;
  
//     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
    
//     if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Print Report</title>
//                     <style>
//                         @media print {
//                             @page {
//                                 size: A4 Portrait;
//                                 margin: 5mm;
//                             }
//                             body {
//                                 font-family: Arial, sans-serif;
//                                 margin: 0;
//                                 padding: 0;
//                                 font-size: 14px !important;
//                             }
//                             .print-section {
//                                 width: 100%;
//                                 margin: 0 auto;
//                                 padding: 0;
//                             }
//                             table {
//                                 width: auto !important;
//                                 border-collapse: collapse;
//                                 table-layout: auto;
//                                 page-break-inside: auto;
//                                 border: 2px solid black !important; /* Thicker outer border */
//                             }
//                             tr {
//                                 page-break-inside: avoid;
//                                 page-break-after: auto;
//                             }
//                             th, td {
//                                 padding: 4px 5px !important;
//                                 border: 1px solid black !important;
//                                 font-size: 14px;
//                                 line-height: 1.2;
//                                 white-space: nowrap;
//                             }
//                             /* Ensure the rightmost column has a proper right border */
//                             tr td:last-child,
//                             tr th:last-child {
//                                 border-right: 2px solid black !important;
//                             }
//                             /* Ensure the top row has proper top border */
//                             tr:first-child td,
//                             tr:first-child th {
//                                 border-top: 2px solid black !important;
//                             }
//                             /* Ensure the leftmost column has proper left border */
//                             tr td:first-child,
//                             tr th:first-child {
//                                 border-left: 2px solid black !important;
//                             }
//                             /* Ensure the bottom row has proper bottom border */
//                             tr:last-child td,
//                             tr:last-child th {
//                                 border-bottom: 2px solid black !important;
//                             }
//                             th {
//                                 background-color: #f2f2f2;
//                                 font-weight: bold;
//                             }
//                             tr {
//                                 border-bottom: 1px solid black !important;
//                             }
//                             tr.header-row {
//                                 display: table-header-group;
//                             }
//                             td[data-type="number"],
//                             td.amount,
//                             td.balance-value,
//                             td:nth-child(n+12) {
//                                 text-align: end !important;
//                             }
//                             td.text,
//                             td[data-type="string"] {
//                                 text-align: left !important;
//                             }
//                             .br-right { border-right: 1px solid black !important; }
//                             .br-rightt { border-right: 1px solid black !important; }
//                             .br-bottom { border-bottom: 1px solid black !important; }
//                             .br-top { border-top: 1px solid black !important; }
//                             .noPrint { display: none !important; }
//                             .footer-line {
//                                 position: fixed;
//                                 bottom: 0;
//                                 left: 0;
//                                 width: 100%;
//                                 height: 1px;
//                                 background-color: black;
//                             }
//                             thead { 
//                                 display: table-header-group; 
//                                 border: 2px solid black !important;
//                             }
//                             tfoot { 
//                                 display: table-footer-group; 
//                                 border: 2px solid black !important;
//                             }
//                             /* Ensure all borders are displayed */
//                             table, th, td {
//                                 border-style: solid !important;
//                                 border-width: 1px !important;
//                                 border-color: black !important;
//                             }
//                             /* Make sure header repeats on each page */
//                             thead tr {
//                                 display: table-row !important;
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <div class="print-section">
//                         ${printContent}
//                         <div class="footer-line"></div>
//                     </div>
//                     <script>
//                        window.onload = function () {
//                            const table = document.querySelector('table');
//                            if (!table) {
//                                console.error("Table not found");
//                                return;
//                            }

//                            // Auto-size columns based on content
//                            table.style.width = 'auto';
//                            const cols = table.querySelectorAll('td, th');
//                            cols.forEach(cell => {
//                                cell.style.width = 'auto';
//                                cell.style.whiteSpace = 'nowrap';
//                            });

//                            let headerRowIndex = -1;
//                            const maxRowsToCheck = Math.min(10, table.rows.length);

//                            // Find header row with column names
//                            for (let i = 0; i < maxRowsToCheck; i++) {
//                                const row = table.rows[i];
//                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

//                                if (row.cells.length >= 8 &&
//                                    (cellTexts.includes('Invoice No') ||
//                                     cellTexts.includes('Receipt No') ||
//                                     cellTexts.includes('Balance'))) {
//                                    headerRowIndex = i;
//                                    break;
//                                }
//                            }

//                            if (headerRowIndex >= 0) {
//                                // Create thead and move only the actual header row into it
//                                let thead = table.querySelector('thead');
//                                if (!thead) {
//                                    thead = document.createElement('thead');
//                                    table.insertBefore(thead, table.firstChild);
//                                }

//                                const headerRow = table.rows[headerRowIndex];
//                                thead.appendChild(headerRow.cloneNode(true));
//                            }

//                            // Alignment processing
//                            const cells = document.querySelectorAll('td');
//                            cells.forEach(cell => {
//                                const content = cell.textContent.trim();

//                                if (content.includes('येणे') ||
//                                    content.includes('Opening Balance') ||
//                                    content.match(/^\\d+\\s+येणे$/) ||
//                                    content.includes('Balance C/F') ||
//                                    content.includes('Total')) {
//                                    cell.style.textAlign = 'right';
//                                    cell.classList.add('balance-value');
//                                }

//                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
//                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
//                                    cell.style.textAlign = 'right';
//                                    cell.classList.add('amount');
//                                }

//                                cell.style.border = '1px solid black';
//                            });

//                            // Force outer border on table after all processing
//                            setTimeout(() => {
//                                table.style.border = '2px solid black';
                               
//                                // Ensure rightmost cells have thick right border
//                                const rows = table.querySelectorAll('tr');
//                                rows.forEach(row => {
//                                    const lastCell = row.querySelector('td:last-child, th:last-child');
//                                    if (lastCell) {
//                                        lastCell.style.borderRight = '2px solid black';
//                                    }
//                                });
                               
//                            }, 100);

//                            setTimeout(() => {
//                                window.print();
//                                setTimeout(() => { window.close(); }, 500);
//                            }, 200);
//                        };
//                     </script>
//                 </body>
//             </html>
//         `);
//         printWindow.document.close();
//     } else {
//         console.error("Failed to open print window.");
//     }
// }

// printPage() {
//     this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//         console.error("Print section not found!");
//         return;
//     }
  
//     const printContent = printSection.innerHTML;
  
//     const screenWidth = window.screen.availWidth;
//     const windowWidth = 1000;
//     const leftPosition = screenWidth - windowWidth - 50;
  
//     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
//     if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Print Report</title>
//                     <style>
//                         @media print {
//                             @page {
//                                 size: A4 Portrait;
//                                 margin: 15mm 10mm; /* Increased margins to prevent cutting */
//                             }
//                             body {
//                                 font-family: Arial, sans-serif;
//                                 margin: 0;
//                                 padding: 5mm; /* Add padding inside body */
//                                 font-size: 15px !important;
//                             }
//                             .print-section {
//                                 width: 100%;
//                                 margin: 0 auto;
//                                 padding: 5mm; /* Additional padding for content */
//                                 box-sizing: border-box;
//                             }
//                             table {
//                                 width: auto !important;
//                                 border-collapse: collapse;
//                                 table-layout: auto;
//                                 page-break-inside: auto;
//                                 border: 2px solid black !important;
//                                 margin: 0 auto; /* Center table if needed */
//                             }
//                             tr {
//                                 page-break-inside: avoid;
//                                 page-break-after: auto;
//                             }
//                             th, td {
//                                 padding: 4px 5px !important;
//                                 border: 1px solid black !important;
//                                 font-size: 14px;
//                                 line-height: 1.2;
//                                 white-space: nowrap;
//                             }
//                             /* Outer border enforcement */
//                             table {
//                                 outline: 2px solid black; /* Use outline instead of border for outer edge */
//                                 outline-offset: -2px; /* Pull outline inward */
//                             }
                            
//                             /* Ensure the rightmost column has a proper right border */
//                             tr td:last-child,
//                             tr th:last-child {
//                                 border-right: 2px solid black !important;
//                             }
//                             /* Ensure the top row has proper top border */
//                             tr:first-child td,
//                             tr:first-child th {
//                                 border-top: 2px solid black !important;
//                             }
//                             /* Ensure the leftmost column has proper left border */
//                             tr td:first-child,
//                             tr th:first-child {
//                                 border-left: 2px solid black !important;
//                             }
//                             /* Ensure the bottom row has proper bottom border */
//                             tr:last-child td,
//                             tr:last-child th {
//                                 border-bottom: 2px solid black !important;
//                             }
//                             th {
//                                 background-color: #f2f2f2;
//                                 font-weight: bold;
//                             }
//                             tr {
//                                 border-bottom: 1px solid black !important;
//                             }
//                             tr.header-row {
//                                 display: table-header-group;
//                             }
//                             td[data-type="number"],
//                             td.amount,
//                             td.balance-value,
//                             td:nth-child(n+12) {
//                                 text-align: end !important;
//                             }
//                             td.text,
//                             td[data-type="string"] {
//                                 text-align: left !important;
//                             }
//                             .br-right { border-right: 1px solid black !important; }
//                             .br-rightt { border-right: 1px solid black !important; }
//                             .br-bottom { border-bottom: 1px solid black !important; }
//                             .br-top { border-top: 1px solid black !important; }
//                             .noPrint { display: none !important; }
//                             .footer-line {
//                                 display: none; /* Remove fixed footer that can cause issues */
//                             }
//                             thead { 
//                                 display: table-header-group; 
//                                 border: 2px solid black !important;
//                             }
//                             tfoot { 
//                                 display: table-footer-group; 
//                                 border: 2px solid black !important;
//                             }
//                             /* Ensure all borders are displayed */
//                             table, th, td {
//                                 border-style: solid !important;
//                                 border-width: 1px !important;
//                                 border-color: black !important;
//                                 -webkit-print-color-adjust: exact;
//                                 print-color-adjust: exact;
//                             }
//                             /* Make sure header repeats on each page */
//                             thead tr {
//                                 display: table-row !important;
//                             }
//                         }
                        
//                         /* Screen view styles */
//                         @media screen {
//                             body {
//                                 padding: 20px;
//                                 background: #f0f0f0;
//                             }
//                             .print-section {
//                                 background: white;
//                                 padding: 20px;
//                                 box-shadow: 0 0 10px rgba(0,0,0,0.1);
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <div class="print-section">
//                         ${printContent}
//                     </div>
//                     <script>
//                        window.onload = function () {
//                            const table = document.querySelector('table');
//                            if (!table) {
//                                console.error("Table not found");
//                                return;
//                            }

//                            // Auto-size columns based on content
//                            table.style.width = 'auto';
//                            const cols = table.querySelectorAll('td, th');
//                            cols.forEach(cell => {
//                                cell.style.width = 'auto';
//                                cell.style.whiteSpace = 'nowrap';
//                            });

//                            let headerRowIndex = -1;
//                            const maxRowsToCheck = Math.min(10, table.rows.length);

//                            // Find header row with column names
//                            for (let i = 0; i < maxRowsToCheck; i++) {
//                                const row = table.rows[i];
//                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

//                                if (row.cells.length >= 8 &&
//                                    (cellTexts.includes('Invoice No') ||
//                                     cellTexts.includes('Receipt No') ||
//                                     cellTexts.includes('Balance'))) {
//                                    headerRowIndex = i;
//                                    break;
//                                }
//                            }

//                            if (headerRowIndex >= 0) {
//                                // Create thead and move only the actual header row into it
//                                let thead = table.querySelector('thead');
//                                if (!thead) {
//                                    thead = document.createElement('thead');
//                                    table.insertBefore(thead, table.firstChild);
//                                }

//                                const headerRow = table.rows[headerRowIndex];
//                                thead.appendChild(headerRow.cloneNode(true));
//                            }

//                            // Alignment processing
//                            const cells = document.querySelectorAll('td');
//                            cells.forEach(cell => {
//                                const content = cell.textContent.trim();

//                                if (content.includes('येणे') ||
//                                    content.includes('Opening Balance') ||
//                                    content.match(/^\d+\s+येणे$/) ||
//                                    content.includes('Balance C/F') ||
//                                    content.includes('Total')) {
//                                    cell.style.textAlign = 'right';
//                                    cell.classList.add('balance-value');
//                                }

//                                const numericPattern = /^-?\d+(,\d{3})*(\.\d+)?$/;
//                                if (numericPattern.test(content.replace(/[\s,]/g, ''))) {
//                                    cell.style.textAlign = 'right';
//                                    cell.classList.add('amount');
//                                }

//                                cell.style.border = '1px solid black';
//                            });

//                            // Apply outer borders more reliably
//                            setTimeout(() => {
//                                // Set table border and outline
//                                table.style.border = '2px solid black';
//                                table.style.outline = '2px solid black';
//                                table.style.outlineOffset = '-2px';
                               
//                                // Ensure edge cells have thick borders
//                                const rows = table.querySelectorAll('tr');
                               
//                                rows.forEach((row, rowIndex) => {
//                                    const cells = row.querySelectorAll('td, th');
//                                    cells.forEach((cell, cellIndex) => {
//                                        // First row - thick top border
//                                        if (rowIndex === 0) {
//                                            cell.style.borderTop = '2px solid black';
//                                        }
//                                        // Last row - thick bottom border
//                                        if (rowIndex === rows.length - 1) {
//                                            cell.style.borderBottom = '2px solid black';
//                                        }
//                                        // First column - thick left border
//                                        if (cellIndex === 0) {
//                                            cell.style.borderLeft = '2px solid black';
//                                        }
//                                        // Last column - thick right border
//                                        if (cellIndex === cells.length - 1) {
//                                            cell.style.borderRight = '2px solid black';
//                                        }
//                                    });
//                                });
//                            }, 100);

//                            setTimeout(() => {
//                                window.print();
//                                setTimeout(() => { window.close(); }, 500);
//                            }, 300);
//                        };
//                     </script>
//                 </body>
//             </html>
//         `);
//         printWindow.document.close();
//     } else {
//         console.error("Failed to open print window.");
//     }
// }


printPage() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
        console.error("Print section not found!");
        return;
    }
  
    const printContent = printSection.innerHTML;
  
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;
  
    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        
                        @media print {
                            @page {
                                size: A4 Portrait;
                                margin: 20mm 15mm; /* Adequate margins for all printers */
                            }
                            
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 14px !important;
                                width: 100%;
                            }
                            
                            .print-section {
                                width: 100%;
                                max-width: 100%;
                                margin: 0;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: flex-start;
                            }
                            
                            table {
                                width: auto !important;
                                max-width: 95%; /* Prevent overflow */
                                border-collapse: collapse;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 2px solid black !important;
                                margin: 0 auto !important; /* Center the table */
                                display: table;
                            }
                            
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            
                            th, td {
                                padding: 4px 8px !important;
                                border: 1px solid black !important;
                                font-size: 14px;
                                line-height: 1.3;
                                white-space: nowrap;
                            }
                            
                            /* Outer border enforcement - thick borders on edges */
                            tr:first-child td,
                            tr:first-child th {
                                border-top: 2px solid black !important;
                            }
                            
                            tr:last-child td,
                            tr:last-child th {
                                border-bottom: 2px solid black !important;
                            }
                            
                            tr td:first-child,
                            tr th:first-child {
                                border-left: 2px solid black !important;
                            }
                            
                            tr td:last-child,
                            tr th:last-child {
                                border-right: 2px solid black !important;
                            }
                            
                            th {
                                background-color: #f2f2f2 !important;
                                font-weight: bold;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            
                            tr {
                                border-bottom: 1px solid black !important;
                            }
                            
                            tr.header-row {
                                display: table-header-group;
                            }
                            
                            /* Alignment for numeric columns */
                            td[data-type="number"],
                            td.amount,
                            td.balance-value,
                            td:nth-child(n+12) {
                                text-align: right !important;
                            }
                            
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            
                            .br-right { border-right: 1px solid black !important; }
                            .br-rightt { border-right: 1px solid black !important; }
                            .br-bottom { border-bottom: 1px solid black !important; }
                            .br-top { border-top: 1px solid black !important; }
                            .noPrint { display: none !important; }
                            
                            thead { 
                                display: table-header-group; 
                            }
                            
                            tfoot { 
                                display: table-footer-group;
                            }
                            
                            /* Ensure all borders are displayed */
                            table, th, td {
                                border-style: solid !important;
                                border-color: black !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                        }
                        
                        /* Screen view styles */
                        @media screen {
                            body {
                                padding: 20px;
                                background: #f0f0f0;
                                display: flex;
                                justify-content: center;
                            }
                            
                            .print-section {
                                background: white;
                                padding: 20px;
                                box-shadow: 0 0 10px rgba(0,0,0,0.1);
                                max-width: 210mm;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                            }
                            
                            table {
                                margin: 0 auto !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                    </div>
                    <script>
                       window.onload = function () {
                           const table = document.querySelector('table');
                           if (!table) {
                               console.error("Table not found");
                               return;
                           }

                           // Center the table explicitly
                           table.style.margin = '0 auto';
                           table.style.display = 'table';
                           
                           // Auto-size columns based on content
                           table.style.width = 'auto';
                           table.style.maxWidth = '95%';
                           
                           const cols = table.querySelectorAll('td, th');
                           cols.forEach(cell => {
                               cell.style.width = 'auto';
                               cell.style.whiteSpace = 'nowrap';
                           });

                           let headerRowIndex = -1;
                           const maxRowsToCheck = Math.min(10, table.rows.length);

                           // Find header row with column names
                           for (let i = 0; i < maxRowsToCheck; i++) {
                               const row = table.rows[i];
                               const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

                               if (row.cells.length >= 8 &&
                                   (cellTexts.includes('Invoice No') ||
                                    cellTexts.includes('Receipt No') ||
                                    cellTexts.includes('Balance') ||
                                    cellTexts.includes('Total GST') ||
                                    cellTexts.includes('Total Inv. Amount'))) {
                                   headerRowIndex = i;
                                   break;
                               }
                           }

                           if (headerRowIndex >= 0) {
                               // Create thead and move only the actual header row into it
                               let thead = table.querySelector('thead');
                               if (!thead) {
                                   thead = document.createElement('thead');
                                   table.insertBefore(thead, table.firstChild);
                               }

                               const headerRow = table.rows[headerRowIndex];
                               thead.appendChild(headerRow.cloneNode(true));
                           }

                           // Alignment processing
                           const cells = document.querySelectorAll('td');
                           cells.forEach(cell => {
                               const content = cell.textContent.trim();

                               if (content.includes('येणे') ||
                                   content.includes('Opening Balance') ||
                                   content.match(/^\d+\s+येणे$/) ||
                                   content.includes('Balance C/F') ||
                                   content.includes('Total')) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('balance-value');
                               }

                               const numericPattern = /^-?\d+(,\d{3})*(\.\d+)?$/;
                               if (numericPattern.test(content.replace(/[\s,]/g, ''))) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('amount');
                               }

                               cell.style.border = '1px solid black';
                           });

                           // Apply outer borders more reliably
                           setTimeout(() => {
                               // Set table border
                               table.style.border = '2px solid black';
                               
                               // Ensure edge cells have thick borders
                               const rows = table.querySelectorAll('tr');
                               
                               rows.forEach((row, rowIndex) => {
                                   const cells = row.querySelectorAll('td, th');
                                   cells.forEach((cell, cellIndex) => {
                                       // First row - thick top border
                                       if (rowIndex === 0) {
                                           cell.style.borderTop = '2px solid black';
                                       }
                                       // Last row - thick bottom border
                                       if (rowIndex === rows.length - 1) {
                                           cell.style.borderBottom = '2px solid black';
                                       }
                                       // First column - thick left border
                                       if (cellIndex === 0) {
                                           cell.style.borderLeft = '2px solid black';
                                       }
                                       // Last column - thick right border
                                       if (cellIndex === cells.length - 1) {
                                           cell.style.borderRight = '2px solid black';
                                       }
                                   });
                               });
                               
                               // Final check to center table
                               table.style.marginLeft = 'auto';
                               table.style.marginRight = 'auto';
                               
                           }, 100);

                           setTimeout(() => {
                               window.print();
                               setTimeout(() => { window.close(); }, 500);
                           }, 300);
                       };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}

}
